
import Vue, { PropType } from "vue";
import { dispatch, SubOrder } from "@/store";

export default Vue.extend({
  name: "VSubOrderSnCodes",
  props: {
    subOrder: Object as PropType<SubOrder>
  },
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      lodaing: false
    };
  },
  methods: {
    onAddExpress() {
      this.visible = true;
      setTimeout(() => {
        this.form.resetFields();
        this.form.setFieldsValue({
          sub_order_no: this.subOrder.sub_order_no
        });
      }, 200);
    },
    onEditExpress() {
      this.visible = true;
      setTimeout(() => {
        this.form.resetFields();
        this.form.setFieldsValue({
          id: this.subOrder.express.id,
          supplier: this.subOrder.express.supplier,
          express_no: this.subOrder.express.express_no
        });
      }, 200);
    },
    onOk() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.lodaing = true;
          dispatch
            .ordersExpressPost(values)
            .then(() => {
              this.visible = false;
              this.lodaing = false;
              this.$message.success("发货成功");
              this.$emit("change");
            })
            .catch(() => {
              this.lodaing = false;
            });
        }
      });
    }
  }
});
